var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "d-flex flex-column flex-md-row" },
    [
      _c(
        "v-col",
        {
          staticClass: "flex-sm-wrap flex-sm-column",
          attrs: { cols: "12", md: "6" },
        },
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "a",
                  { attrs: { href: _vm.largeLeft.href } },
                  [
                    _c("BaseImage", {
                      attrs: {
                        mobileSrc: _vm.largeLeft.mobileSrc,
                        desktopSrc: _vm.largeLeft.desktopSrc,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "flex-sm-wrap" },
            [
              _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                _c(
                  "a",
                  { attrs: { href: _vm.smallLeft1.href } },
                  [
                    _c("BaseImage", {
                      attrs: {
                        mobileSrc: _vm.smallLeft1.mobileSrc,
                        desktopSrc: _vm.smallLeft1.desktopSrc,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                _c(
                  "a",
                  { attrs: { href: _vm.smallLeft2.href } },
                  [
                    _c("BaseImage", {
                      attrs: {
                        mobileSrc: _vm.smallLeft2.mobileSrc,
                        desktopSrc: _vm.smallLeft2.desktopSrc,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass: "flex-sm-wrap flex-sm-column",
          attrs: { cols: "12", md: "6" },
        },
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                _c(
                  "a",
                  { attrs: { href: _vm.smallRight1.href } },
                  [
                    _c("BaseImage", {
                      attrs: {
                        mobileSrc: _vm.smallRight1.mobileSrc,
                        desktopSrc: _vm.smallRight1.desktopSrc,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                _c(
                  "a",
                  { attrs: { href: _vm.smallRight2.href } },
                  [
                    _c("BaseImage", {
                      attrs: {
                        mobileSrc: _vm.smallRight2.mobileSrc,
                        desktopSrc: _vm.smallRight2.desktopSrc,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "flex-sm-wrap" },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "a",
                  { attrs: { href: _vm.largeRight.href } },
                  [
                    _c("BaseImage", {
                      attrs: {
                        mobileSrc: _vm.largeRight.mobileSrc,
                        desktopSrc: _vm.largeRight.desktopSrc,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }